import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'MATZEVA_FORM', {
  TITLE: 'Matzeva Procedure Form',
  PERSON: 'Person',
  CEMENTERY: 'Cementery',
  DETAILS: 'Details',
  APPLICANT: 'Applicant',
  COMMENTS: 'Comments',
  PERSON_INFORMATION: 'Person information',
  CEMENTERY_INFORMATION: 'Cementery location information',
  DETAILS_INFORMATION: 'Details information',
  APPLICANT_INFORMATION: 'Applicant information',
  NAME: 'First name',
  LAST_NAME: 'Last name',
  MOTHER_NAME: 'Mother name',
  DEATH_DATE: 'Death date',
  DEATH_DATE_HEBREW: 'Death date in Hebrew',
  LOCATION: 'Location',
  SKETCH: 'Sketch',
  SKETCH_FILE: 'Sketch file',
  SPANISH_FILE: 'Spanish file',
  HEBREW_FILE: 'Hebrew file',
  TEXT: 'Text',
  MATZEVA_FILE: 'Matzeva file',
  MARBLE_WORKER_NAME: 'Marble worker name',
  COLOR: 'Color',
  MATERIALS: 'Materials',
  DIMENSIONS: 'Dimensions',
  APPLICANT_NAME: 'Applicant name',
  SUBMIT_BUTTON: 'Submit',
  LOADING: 'Loading...',
  SKETCH_DESC: 'Image or PDF of the cementery location sketch.',
  SPANISH_DESC: 'Document with the text to be written in Spanish.',
  HEBREW_DESC: 'Document with the text to be written in Hebrew.',
  MATZEVA_DESC: 'Final design or visual design of the plaque/monument.',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'MATZEVA_FORM', {
  TITLE: 'Formulario de Matzeva',
  PERSON: 'Persona',
  CEMENTERY: 'Cementerio',
  DETAILS: 'Detalles',
  APPLICANT: 'Solicitante',
  COMMENTS: 'Observaciones',
  PERSON_INFORMATION: 'Datos del fallecido/a',
  CEMENTERY_INFORMATION: 'Información de la ubicación de la matzeva',
  DETAILS_INFORMATION: 'Detalles adicionales',
  APPLICANT_INFORMATION: 'Datos del solicitante',
  NAME: 'Nombre',
  LAST_NAME: 'Apellido',
  MOTHER_NAME: 'Nombre de la madre',
  DEATH_DATE: 'Fecha de fallecimiento',
  DEATH_DATE_HEBREW: 'Fecha de fallecimiento en hebreo',
  LOCATION: 'Ubicación',
  SKETCH: 'Croquis',
  SKETCH_FILE: 'Archivo de croquis',
  SPANISH_FILE: 'Archivo en español',
  HEBREW_FILE: 'Archivo en hebreo',
  TEXT: 'Texto en castellano y hebreo',
  MATZEVA_FILE: 'Archivo de matzeva',
  MARBLE_WORKER_NAME: 'Marmolero que hace la matzeva',
  COLOR: 'Color',
  MATERIALS: 'Materiales',
  DIMENSIONS: 'Medidas',
  APPLICANT_NAME: 'Nombre del solicitante',
  SUBMIT_BUTTON: 'Enviar',
  LOADING: 'Cargando...',
  SKETCH_DESC: 'Imagen o PDF del plano de ubicación en el cementerio.',
  SPANISH_DESC: 'Documento con el texto que irá grabado en castellano.',
  HEBREW_DESC: 'Documento con el texto que irá grabado en hebreo.',
  MATZEVA_DESC: 'Diseño final o boceto visual de la placa/monumento.',
});
